import colors from 'seagull/foundations/colors.module.scss';
import { RevenueStatus } from '~/models/HistoricRevenueModel';
const paidColor = colors.purple700;
const expectedColor = colors.dark200;
const paidExternallyColor = colors.purple300;
export const revenueWidgetTextsPath = 'pages.dashboard.revenueWidget';
export const revenueStatusOrder = [
    RevenueStatus.Paid,
    RevenueStatus.PaidExternally,
    RevenueStatus.Expected
];
export const colorsMap = {
    [RevenueStatus.Paid]: paidColor,
    [RevenueStatus.Expected]: expectedColor,
    [RevenueStatus.PaidExternally]: paidExternallyColor
};
export const getLabelMap = (legendTexts)=>({
        [RevenueStatus.Paid]: legendTexts.paidViaAnchor(),
        [RevenueStatus.Expected]: legendTexts.expected(),
        [RevenueStatus.PaidExternally]: legendTexts.paidExternally()
    });
export const getLegendItems = (data, legendTexts)=>revenueStatusOrder.filter((status)=>data.some((item)=>item[status].totalAmount.gt(0))).map((status)=>({
            status,
            label: getLabelMap(legendTexts)[status],
            color: colorsMap[status]
        }));
